import {
  getStoreProducts,
  getStoreCategorys,
  getProductsByCategory,
  getProductsBySubcategory,
  getProductsPromotions,
  getBanner,
  getProducts,
  getStores,
  validateCustomerAddress,
  transferCart,
  getAvailableCoupons,
} from '@/api/index'
import CartStore from '../CartStore';
import {
  Models
} from 'sr-js-lib';
export default {
  namespaced: true,
  state: {
    // loading: {},
    productList: {
      promotions: [],
      products: [],
    },
    categorysList: [],
    bannerList: [],
    productsSearch: [],
    loadings: {
      searchProducts: true,
      indexProducts: true,
      banners: true,
      categories: true,
    },
    searchParams: {
      categoryId: null,
      subcategoryId: null,
      keys: null,
    },
    resultsParams: {
      total: 0,
      qty: 0,
      page: 1,
      next: false,
    },
    storeList: [],
    currentStore: null,
    adminOrder: false,
    validAddress: false,
    initialAddress: Models.M_customer(),
    coupons: [],
  },

  getters: {
    getStoreList(state) {
      return state.storeList;
    },
    getCurrentStore(state) {
      return state.currentStore;
    },
    getValidAddress(state) {
      return state.validAddress;
    },
    getInitialAddress(state) {
      return state.initialAddress;
    },
    getCarousel(state) {
      let banners = state.bannerList.filter(item => item.position == 1);
      banners.sort((a, b) => {
        return a.orden - b.orden;
      });
      return banners;
    },
    getBanner(state) {
      let banners = state.bannerList.filter(item => item.position == 2);
      banners.sort((a, b) => {
        return a.orden - b.orden;
      });
      return banners;
    },
    getSection(state) {
      if (state.searchParams.keys){
        return state.searchParams.keys;
      }
      if (state.searchParams.categoryId) {
        if (state.searchParams.subcategoryId) {
          let category = state.categorysList.find( item => item.category_id == state.searchParams.categoryId);
          let result =  category.subcategories.find(item => item.family_id == state.searchParams.subcategoryId);
          return result ? result.label : '';
        } else {
          let result = state.categorysList.find( item => item.category_id == state.searchParams.categoryId);
          return result ? result.label : '';
        }
      }
      return state.searchParams.keys;
    },
    getCouponsList(state){
      return state.coupons;
    },
    getSearchBanners: (state) => (categories) => {
      let banners = state.bannerList;
      let response = []
      for(let i = 0; i < banners.length; i++){
        if(categories.includes(banners[i].category_id)){
          response.push(banners[i]);
        }
      }

      response.sort((a, b) => {
        return a.orden - b.orden;
      });
      return response;
    },
  },


  mutations: {
    setLoading(state, loading) {
      state.loadings = {
        ...state.loadings,
        ...loading
      };
    },
    setSearchParams(state, params) {
      state.searchParams = {
        ...state.searchParams,
        ...params
      };
    },
    setProductList(state, lists) {
      state.productList = {
        ...state.productList,
        ...lists
      };
    },
    setCategorysList(state, list) {
      state.categorysList = [...list];
    },
    setProductsSearch(state, list) {
      state.productsSearch = [...list];
    },
    setBannerList(state, list) {
      state.bannerList = [...list];
    },
    setResultsParams(state, object) {
      state.resultsParams = {...object};
    },
    setStoreList(state, list) {
      state.storeList = [...list];
    },
    setCurrentStore(state, store) {
      state.currentStore = store;
    },
    setAdminOrder(state, admin_order) {
      state.adminOrder = admin_order;
    },
    setValidAddress(state, valid) {
      state.validAddress = valid;
    },
    setInitialAddress(state, address) {
      state.initialAddress = address;
    },
    setCoupons(state, coupons){
      state.coupons = coupons;
    },
  },

  actions: {
    /* = Methods */
    async fnApiGetStoreList(context) {
      await getStores().then(res => {
        context.commit('setStoreList', res);
        if(context.state.currentStore == null){
          context.commit('setCurrentStore', res[0])
        }
        
      }).catch((e) => {});
    },
    async fnApiGetStoreProducts(context) {
      let store_id = context.state.currentStore.store_id;
      await getStoreProducts(store_id).then(res => {
        context.commit('setProductList', res);
      }).catch((e) => {});
    },
    async fnApiGetCategorys(context) {
        await getStoreCategorys().then(res => {
          context.commit('setCategorysList', res);
        }).catch((e) => {});
    },

    async fnApiGetBanners(context) {
      await getBanner().then(res => {
        context.commit('setBannerList', res);
      }).catch((e) => {});
    },

    async fnApiGetProducts(context, [promotions, page, qty]) {
      context.commit('setLoading', {
        searchProducts: true
      });

      if( promotions ){
        await context.dispatch('fnApiGetPromotions', [page, qty]).catch((e) => {});
      }else{

        let searchParams = context.state.searchParams;
        if (searchParams.keys) {
          let store_id = context.state.currentStore.store_id;
          await getProducts(store_id, searchParams.keys, searchParams.categoryId).then(res => {
            context.commit('setProductsSearch', res);
          }).catch((e) => {});
        } else {
          if (searchParams.categoryId) {
            if (searchParams.subcategoryId) {
              await context.dispatch('fnApiGetProductsBySubcategory', [searchParams.categoryId, searchParams.subcategoryId, page, qty])
            } else {
              await context.dispatch('fnApiGetProductsByCategory', [searchParams.categoryId, page, qty]);
            }
          }
        }
      }

    
      setTimeout(() => {
        context.commit('setLoading', {
          searchProducts: false
        });
      }, 200);
    },

    async fnApiGetProductsByCategory(context, [categorId, page, qty]) {
      let store_id = context.state.currentStore.store_id;
      await getProductsByCategory(store_id, categorId, page, qty).then(res => {
        context.commit('setProductsSearch', res.products);
        let paging = {
          total: res.total,
          qty: res.qty,
          page: res.page,
          next: res.next,
        }
        context.commit('setResultsParams', paging);
      }).catch((e) => {});
    },

    async fnApiGetProductsBySubcategory(context, [categorId, subcategoryId, page, qty]) {
      let store_id = context.state.currentStore.store_id;
      await getProductsBySubcategory(store_id, categorId, subcategoryId, page, qty).then(res => {
        context.commit('setProductsSearch', res.products);
        let paging = {
          total: res.total,
          qty: res.qty,
          page: res.page,
          next: res.next,
        }
        context.commit('setResultsParams', paging);
      }).catch((e) => {});
    },

    async fnApiGetPromotions(context, [page, qty]) {
      let store_id = context.state.currentStore.store_id;
      await getProductsPromotions(store_id, page, qty).then(res => {
        context.commit('setProductsSearch', res.products);
        let paging = {
          total: res.total,
          qty: res.qty,
          page: res.page,
          next: res.next,
        }
        context.commit('setResultsParams', paging);
      }).catch((e) => {});
    },

    async fnApiValidateDeliveryAddress(context) {
      let store_id = context.state.currentStore.store_id;
      let params = {
        latitude: context.state.initialAddress.latitude,
        longitude: context.state.initialAddress.longitude,
      }
      return await validateCustomerAddress(store_id, params).then(async res => {
        if(res.valid){
          context.state.validAddress = true;
          return 1;
        }else{
          context.state.validAddress = true;
          const resStore = res.store;
          let store = context.state.storeList.find(x => x.store_id == resStore.store_id);
          if(store && context.state.currentStore.store_id != store.store_id){
            context.state.currentStore = store;

            if(CartStore.state.cartProducts && CartStore.state.cartProducts.token){
              let params = {
                store_id: store.store_id
              }
              return await transferCart(CartStore.state.cartProducts.token, params).then(res => {
                return 2;
              }).catch((e) => {
                return 0;
              });
            }else{
              return 2;
            }
          }
        }
      }).catch((e) => {
        if(e.response.data.error_code == 43){
          return 3;  
        }
        return 0;
      });
    },
    async fnApiGetAvailableCoupons(context) {
      let store_id = context.state.currentStore.store_id;
      await getAvailableCoupons(store_id).then(res => {
        context.commit('setCoupons', res.coupons);
      }).catch((e) => {});
    },

  },

  modules: {
    CartStore: CartStore,
  },

};
